export default __webpack_public_path__ + "static/media/chim1.bf110d61.webp";